export default "__VITE_ASSET__Djdc0OZU__"